import $ from 'jquery';
import CONSTANT from '../../common/js/_constant';
import {calculators}  from '../../common/js/calculator';
import ppfCalculator from '../ppfCalculator/ppfCalculator';
import { Chart,  registerables, Tooltip  } from 'chart.js/auto';
// (removed an unused `import { GaugeController, ArcElement, NeedleElement } from "chartjs-gauge"`:
// none of those names are used - the gauge below is a Chart.js v4 doughnut - but the import pulled
// chartjs-gauge's own copy of Chart.js v2 plus moment with all locales (~436 KB) into every page.)

const termInsurance = {
    variables :{
        termInsuranceNextButton : '.term-insurance__buttons--next',
        termInsurancePrevButton : '.term-insurance__buttons--prev',
        termInsuranceFormSubmit : '.term-insurance__forms',
        termInsuranceAnwers: '.term-insurance__wrapper--answers',
        termInsuranceAmountRupee:'.chli__calculator--label',
        termInsuranceTextPlaceholder: '{amount}',
        termInsuranceTextAmountInput:'.term-insurance--input',
        termInsuranceTextAmountDetails:'.term-insurance__input-div',
        termInsuranceTextAnswersButton:'.term-insurance__answer-buttons--prev',
        termInsuranceDetails:'.term-insurance__forms--details-1',
        termInsuranceStep : '.term-insurance__wrapper--step',
        termInsuranceAnswersWrap:'.term-insurance__graph-details--details',
        termInsuranceAnswersMoney:'.term-insurance__answers-money',
        myGaugeChart: null,
        age: null,
        income: null,
        annual_Income: null,
        name: null,
        mobileNumber: null
    },
    methods : {
        replaceAmountInput : (el)=>{
            const $el = $(el);
            const {termInsuranceTextPlaceholder,termInsuranceTextAmountInput,termInsuranceAmountRupee} = termInsurance.variables;
            let termInsuranePlaceholderText = termInsuranceTextPlaceholder;
            if($el.hasClass('age')){
                termInsuranePlaceholderText = '{age}';
            } else if($el.hasClass('insurance-amount')){
                termInsuranePlaceholderText = '{insurenceamount}';
            } else if($el.hasClass('name')){
                termInsuranePlaceholderText = '{name}';
            } else if($el.hasClass('contact')){
                termInsuranePlaceholderText = '{contact}';
            } 
            const investmentInput = $el.find(termInsuranceTextAmountInput).parent().removeClass('d-none').detach();
            const amountText = $el.find(termInsuranceAmountRupee);
            if(termInsuranceAmountRupee.length > 0){
                const replacedTextEl = amountText.html().replace(termInsuranePlaceholderText, investmentInput.prop('outerHTML'))
                amountText.html(replacedTextEl);
                calculators.methods.currencyFormat();
                calculators.methods.onlyNumbers();
                calculators.methods.onlyText();
            }
        },
        handleTermInsurance : (el)=>{
            const $el = $(el);
            const name = $el.find('.term-insurance__input-div.name').find('input').val();
            const contact=$el.find('.term-insurance__input-div.contact').find('input').val();
            const age = ($el.find('.term-insurance__input-div.age').find('input').val());
            const amount = ppfCalculator.methods.removeCommas($el.find('.term-insurance__input-div.monthly').find('input').val());
            const insurance = ppfCalculator.methods.removeCommas($el.find('.term-insurance__input-div.insurance-amount').find('input').val());
            const loan = ppfCalculator.methods.removeCommas($el.find('.term-insurance__input-div.loan').find('input').val());
            const replcedName = $el.find('.term-insurance__answers-greeting').data('text').replace('{name}',`<span class="text-blue-400">${name.split(' ')[0]}</span>`);
            localStorage.setItem('tic_name',name);
            localStorage.setItem('tic_contact',contact);
            $el.find('.term-insurance__answers-greeting').html(replcedName);
            let additionalCover = termInsurance.methods.findAdditionalCover(age, amount, insurance, loan);
            let needCover = additionalCover-Number(insurance);
            needCover = (needCover <= 0) ? 0 : needCover;
            if(needCover == 0){
                $el.find('.term-insurance__answers-message').addClass('d-none');
                $el.find('term-insurance__graph-details--graph').addClass('d-none');
                $el.find(termInsurance.variables.termInsuranceAnswersMoney).html(`<span class="text-red-300 font-12 leading-13">Seems Yours Goal is already achieved basis inputs provided. Please recalculate if needed!</span>`)
            }else{
                $el.find('.term-insurance__answers-message').removeClass('d-none');
                $el.find('term-insurance__graph-details--graph').removeClass('d-none');
                $el.find(termInsurance.variables.termInsuranceAnswersMoney).html('₹ '+termInsurance.methods.formatNumber(needCover));
            }
            termInsurance.methods.handleGraph(el,additionalCover,insurance);
        },
        formatNumber : (value)=> {
            let formattedValue = value;
            
            if (value >= 10000000) {
                formattedValue = (value / 10000000).toFixed(value % 10000000 === 0 ? 0 : 2) + " Crore";
            } else if (value >= 100000) {
                formattedValue = (value / 100000).toFixed(value % 100000 === 0 ? 0 : 2) + " Lakh";
            } else if (value >= 1000) {
                formattedValue = (value / 1000).toFixed(value % 1000 === 0 ? 0 : 2) + " Thousand";
            }
        
            return formattedValue;
        },
        
        handleGraph : (el,value12, insurance)=>{
            //set labels accordingly
            if(value12 < 0){
                value12  = 0;
                insurance = 0;
            }
            $(el).find('.term-insurance__money-text').each(function(){
                if($(this).hasClass('bottom')){
                    $($(this).find('.term-insurance__money-text--zero')[1]).html(`${termInsurance.methods.formatNumber(value12)}`);
                }
                if($(this).hasClass('mid')){
                    $($(this).find('.term-insurance__money-text--zero')[0]).html(`${termInsurance.methods.formatNumber(value12*25/100)}`);
                    $($(this).find('.term-insurance__money-text--zero')[1]).html(`${termInsurance.methods.formatNumber(value12*75/100)}`);
                }
                if($(this).hasClass('top')){
                    $($(this).find('.term-insurance__money-text--zero')[0]).html(`${termInsurance.methods.formatNumber(value12*50/100)}`);
                }
            })
            if(termInsurance.variables.myGaugeChart){
                termInsurance.variables.myGaugeChart.destroy();
            }
            let paddingValue= 20,fontSize="16px 'Inter', satoshi",xValue = 50, yValue1=20, yValue2=70, HalfWidthValue=60;
            if($(window).wdth < CONSTANT.breakpoints.md){
                paddingValue = 30;
                fontSize="8px 'Inter', satoshi",
                xValue = 10,
                yValue1=10, 
                yValue2=10,
                HalfWidthValue=27
            }
             const dataThirteen = {
                datasets: [{
                  label: 'My First Dataset',
                  data: [50,50,50,50],
                backgroundColor: ['#FFF8E2', '#FFDD78', '#FFC20E', '#EFAC00'],
                borderColor: ['#FFF8E2', '#FFDD78', '#FFC20E', '#EFAC00'],
                  hoverBackgroundColor: ['#FFF8E2', '#FFDD78', '#FFC20E', '#EFAC00'],
                  hoverOffset: 4,
                  cutout:"52%",
                  spacing:0,
                  borderRadius:0,
                  borderWidth:0,
                  circumference: 180,
                  rotation: 270,
                }]
              };
             
              let optionsThirteen = {
                aspectRatio: 1,
                maintainAspectRatio: false,
                layout: {
                    padding: paddingValue
                },
                plugins: {
                  customDatalabels:{},
                  doughnutImgText:{
                     imagePath:"./assets/plane.svg"
                   },
                    legend: {
                      display: false
                    },
                  },
                  Tooltip : {
                    display : false
                  }
              };
              const customDatalabels = {
                id: "customDatalabels",
                labelVisibility: [], // Array to store label visibility states
               
                afterDatasetDraw(chart, args, pluginOptions) {
                  const {
                    ctx,
                    data,
                    chartArea: { top, bottom, left, right, width, height },
                  } = chart;
                  ctx.save();
                  const halfWidth = width / 2 + left;
                  const halfHeight = height / 2 + top;
                  const dataLabel = [12.5,25,50,75];
                  data.datasets[0].data.forEach((datapoint, index) => {
                    if (this.labelVisibility[index]) return;
                    const { x, y } = chart.getDatasetMeta(0).data[index].tooltipPosition();
                    const xLine = x >= halfWidth ? x + xValue : x - xValue;
                    const yLine = y >= halfHeight ? y + yValue1 : y - yValue2;
                    const extraLine = x >= halfWidth ? HalfWidthValue : - HalfWidthValue;
                    const radius = 20; // radius of the circular background
                    ctx.beginPath();
                    ctx.fill();
                    ctx.font = fontSize;
                    ctx.fillStyle = "#7a7a7a"
                    ctx.textAlign = "center";
                    ctx.textBaseline = "middle";
                  });
                },
              };
              const overlappingLinePlugin = {
                id: "overlappingLine",
                    afterDatasetDraw(chart, args, plugins) {
                        const { ctx, data } = chart;
                        const meta = chart.getDatasetMeta(0);
                        const totalData = data.datasets[0].data.length;
                    
                        ctx.save();
                    
                        const xCenter = meta.data[0].x;
                        const yCenter = meta.data[0].y;
                        const outerRadius = meta.data[0].outerRadius;
                        const innerRadius = meta.data[0].innerRadius - 75;
                        const widthSlice = (outerRadius - innerRadius) / 2;
                        const radius = 9;
                        const value = insurance;
                        const maxValue = (value12==0) ?10000000: value12;
                        const angle = Math.PI * (1.5 + (value / maxValue) * 1);
                    
                        const targetIndex = Math.floor(value / maxValue * totalData);
                    
                        meta.data.forEach((dataPoint, index) => {
                        if (index !== targetIndex) {
                            dataPoint.draw(ctx);
                        }
                        });
                    
                        meta.data[targetIndex].draw(ctx);
                    
                        // Draw the needle
                        ctx.translate(xCenter, yCenter);
                        ctx.rotate(angle);
                    
                        ctx.beginPath();
                        ctx.strokeStyle = '#0C73B4';
                        ctx.fillStyle = "#0C73B4";
                        ctx.lineWidth = 1;
                        ctx.moveTo(-radius, 0);
                        ctx.lineTo(0, 0 - innerRadius - widthSlice);
                        ctx.lineTo(radius, 0);
                        ctx.lineTo(0, 10 + 98 - widthSlice);
                        ctx.closePath();
                        ctx.stroke();
                        ctx.fill();
                    
                        ctx.beginPath();
                        ctx.arc(0, 0, radius, 0, 2 * Math.PI);
                        ctx.fill();
                    
                        ctx.fillStyle = "#ffffff";
                        ctx.beginPath();
                        ctx.arc(0, 0, 4, 0, 2 * Math.PI);
                        ctx.fill();
                        ctx.restore();
                        termInsurance.methods.updateSectionWidthAndRadius(chart, value, maxValue);
                    }
              };
              termInsurance.variables.myGaugeChart = new Chart("gaugeChart", {
                type: "doughnut",
                options: optionsThirteen,
                data: dataThirteen,
                plugins:[customDatalabels,overlappingLinePlugin]
              });
        },
        updateSectionWidthAndRadius : (chart, value, maxValue)=>{
            const dataset = chart.data.datasets[0];
            const numberOfSections = dataset.data.length;
            
            const targetIndex = Math.floor(value / maxValue * numberOfSections);
            
            dataset.borderWidth = dataset.data.map(() => 0);
            dataset.borderRadius = dataset.data.map(() => 0);
            
            dataset.borderWidth[targetIndex] = 15;
            dataset.borderRadius[targetIndex] = 1.5;
            
            chart.update();
        },
        requiredValidationOnInput:function(el){
            const $el = $(el);
            $el.find('.term-insurance__answer-buttons--prev').on(CONSTANT.eventsListners.CLICK,(e)=>{
                $el.find(termInsurance.variables.termInsuranceAnwers).addClass('d-none');
                $($el.find(termInsurance.variables.termInsuranceDetails)[0]).addClass('active');
                $el.find(termInsurance.variables.termInsuranceStep).removeClass('active');
                $($el.find(termInsurance.variables.termInsuranceStep)[0]).addClass('active');
                $el.find(termInsurance.variables.termInsuranceNextButton).removeClass('d-none');
                $el.find('.term-insurance__wrapper--mobile-steps').find('.term-insurance__step-text').removeClass('active');
                $($el.find('.term-insurance__wrapper--mobile-steps').find('.term-insurance__step-text')[0]).addClass('active');
            })
            $el.find("input").on(CONSTANT.eventsListners.INPUT,function(e){
                this.style.width = this.value.length + "ch";
                if($(this).hasClass('term-insurance--input-contact')){
                    const mobileValue = $(this).val();
                    if (mobileValue.length > 0 && (!/^[6-9][0-9]*$/.test(mobileValue))) {
                        e.target.value = mobileValue.slice(0, -1);
                    }
                }
            });
        },
        validateAllInputFields : ($el,inputs)=>{
            if(inputs.hasClass('term-insurance--input-age')){
                const $field = $el.find('.term-insurance--input-age');
                if(($field.val() && ($field.val().trim() < 18 || $field.val().trim() > 60))){
                    $field.parent('.error__active').removeClass('error__active');
                    $field.siblings('.error').remove();
                    const $error = $(`<span class="error">Age must be between 18 to 60</span>`);
                    $field.after($error);
                    $field.parent().addClass('error__active');
                }
            }
            if(inputs.hasClass('term-insurance--input-monthly')){
                const $field = $el.find('.term-insurance--input-monthly');
                let monthlyValue = ($field.val()) ? ppfCalculator.methods.removeCommas($field.val()) : '';
                if( monthlyValue && monthlyValue < 5000){
                    $field.parent('.error__active').removeClass('error__active');
                    $field.siblings('.error').remove();
                    const $error = $(`<span class="error">Income must be more than 5000</span>`);
                    $field.after($error);
                    $field.parent().addClass('error__active');
                }
            }
            if(inputs.hasClass('term-insurance--input-contact')){
                const $field = $el.find('.term-insurance--input-contact');
                if($field.val() && !termInsurance.methods.validatePhoneNumber($field.val())){
                    $field.parent('.error__active').removeClass('error__active');
                    $field.siblings('.error').remove();
                    const $error = $(`<span class="error">Phone Number is not Correct</span>`);
                    $field.after($error);
                    $field.parent().addClass('error__active');
                }
            }
        },
        validatePhoneNumber : (value)=>{
            value = value.replace(/[^0-9]/g, '');
            if (value.length === 10 && /^[6789]\d{9}$/.test(value)) {
                return true;
            } else {
                return false;
            }
        },
        findAdditionalCover : (age, amount, insurance, loan)=>{
            return ((10*amount*12)+Number(loan));
        },
        handlePrevNext : (el)=>{
            const $el = $(el);
            const { termInsuranceNextButton ,termInsurancePrevButton , termInsuranceFormSubmit,termInsuranceAnwers } = termInsurance.variables;
            $el.find(termInsuranceFormSubmit).on(CONSTANT.eventsListners.SUBMIT,function(e){
                e.preventDefault();
                calculators.methods.validateRequiredFields();
                termInsurance.methods.validateAllInputFields($el,$el.find("input"));
                const isError = $el.find('.term-insurance__forms--details-1.active').find('.error__active');
                if(isError.length) {return;}
                const isBack = calculators.methods.handleNextPrev(el,false);
                if(isBack){
                    $el.find(termInsurancePrevButton).removeClass('d-none');
                }
                else{
                    $el.find(termInsurancePrevButton).addClass('d-none');
                    $el.find(termInsuranceNextButton).addClass('d-none');
                    $el.find(termInsuranceAnwers).removeClass('d-none');
                    termInsurance.methods.handleTermInsurance(el);
                }
            });
            $el.find(termInsurancePrevButton).on(CONSTANT.eventsListners.CLICK,function(){
                const isBack = calculators.methods.handleNextPrev(el,true);
                if(isBack){
                    $el.find(termInsurancePrevButton).removeClass('d-none');
                }
                else{
                    $el.find(termInsurancePrevButton).addClass('d-none');
                }
            });
        },
        handleAllInputs:(el)=>{
            const $el = $(el);
            $el.find(termInsurance.variables.termInsuranceTextAmountDetails).each((idx,details)=>{
                termInsurance.methods.replaceAmountInput(details);
            })
        },
        handleDataLayer:(el)=>{
            $(el).find('.term-insurance__buttons--next').on('click', function(e){

                let calculatorSection=$(this).closest('.termInsuranceCalculator').find('.term-insurance__step-text.active').text();
                let calculatorName=$(this).closest('.termInsuranceCalculator').find('.term-insurance__wrapper--title').text();
                const name = $(this).parent().prev('.term-insurance__forms--details-1.active').find('input[name="name"]').val();
                const contact=$(this).parent().prev('.term-insurance__forms--details-1.active').find('input[name="contact"]').val();
                termInsurance.variables.name = name;
                termInsurance.variables.mobileNumber = contact;
              
                let container = $(this).closest('.termInsuranceCalculator').find('.term-insurance__forms--details-1.active');
                if(container){
                    if(container.find('.term-insurance--input-age').val()!=null){
                  termInsurance.variables.age = container.find('.term-insurance--input-age').val();
                    }
                    if(container.find('.term-insurance--input-monthly').val()!=null){
                  termInsurance.variables.income = container.find('.term-insurance--input-monthly').val();
                }
            }
              //let annual_Income=null;
            if(termInsurance.variables.income!=null){
                termInsurance.variables.income=termInsurance.variables.income.replaceAll(',','');
                termInsurance.variables.annual_Income=parseInt(termInsurance.variables.income)*12;
            }
                var obj = termInsurance.methods.dataLayerObj(e,calculatorName,calculatorSection, name, contact);
                createDataLayer('buttonClick', obj);
            });
            $(el).find('.term-insurance__buttons--prev').on('click', function(e){
                let calculatorSection=$(this).closest('.termInsuranceCalculator').find('.term-insurance__step-text.active').text();
                let calculatorName=$(this).closest('.termInsuranceCalculator').find('.term-insurance__wrapper--title').text();
              var obj = termInsurance.methods.dataLayerObj(e,calculatorName,calculatorSection);
              createDataLayer('buttonClick', obj);
            });
            $(el).find('.term-insurance__answer-buttons--prev').on('click', function(e){
                let calculatorSection=$(this).closest('.termInsuranceCalculator').find('.term-insurance__step-text.active').text();
                let calculatorName=$(this).closest('.termInsuranceCalculator').find('.term-insurance__wrapper--title').text();
              var obj = termInsurance.methods.dataLayerObj(e,calculatorName,calculatorSection);
              createDataLayer('buttonClick', obj);
            });
            $(el).find('.term-insurance__buttons--answer-next').on('click', function(e){
                let calculatorSection=$(this).closest('.termInsuranceCalculator').find('.term-insurance__step-text.active').text();
                let calculatorName=$(this).closest('.termInsuranceCalculator').find('.term-insurance__wrapper--title').text();
              var obj = termInsurance.methods.dataLayerObj(e,calculatorName,calculatorSection,termInsurance.variables.name,termInsurance.variables.mobileNumber);
              createDataLayer('buttonClick', obj);
            });
        },
        dataLayerObj: function (e,pageSection,section, name, contact, age, income) {
            var obj = {
                'articleName' : "",
                'blogCategory' : "",
                'blogPageCategory' : "",
                'buttonText' : e.currentTarget.innerText.replace(/\n/g, '').trim(),
                'pageSection' : pageSection.replace(/\n/g, '').trim().concat('_').concat(section).replace(/\n/g, '').trim(),
                'pageType' : document.querySelector("meta[name='template']").content == 'chli-base-page-template' ? window.location.href.includes("blog") ? "Blogs" : window.location.href.substring(window.location.href.indexOf(".com/"), window.location.href.lastIndexOf('/')) === ".com" ? "Home" : "Other Pages" : "Blog Details Page",
                'planOption' : "",
                'productCategory' : "",
                'productName' : "",
                'question' : "",
                'source' : "",
                'searchTerm' : "",
                'videoTitle' : "",
                'bannerName' : "",
                'name' : name,
                'mobileNumber' : contact,
                "age": termInsurance.variables.age,
                "annualIncome": termInsurance.variables.annual_Income,
                "countryCode" : "+91",
            };
            return obj;
        },
        init : ()=>{
            if($('.term-insurance').length > 0){
                $('.term-insurance').each((idx,ele)=>{
                    termInsurance.methods.handlePrevNext(ele);
                    termInsurance.methods.handleAllInputs(ele);
                    termInsurance.methods.requiredValidationOnInput(ele);
                    termInsurance.methods.handleDataLayer(ele);
                });
            }
        }
    }
}

$(()=>{
    termInsurance.methods.init();
})